const fullName = user => {
  if(!user) return ""
  return `${user.firstName} ${user.lastName}`
}

export { fullName }